import * as Yup from 'yup';

const validationSchema = Yup.object().shape({
  organization: Yup.number().notOneOf([0], 'Şirket zorunludur.'),
  first_name: Yup.string().required('İsim zorunludur.'),
  last_name: Yup.string().required('Soyisim zorunludur.'),
  turkish_id: Yup.string().required('TCKN zorunludur.'),
  countries: Yup.array()
    .of(Yup.string().required('Ülke zorunludur'))
    .min(1, 'Ülke zorunludur')
    .required('Ülke zorunludur'),
});

export default validationSchema;
